import {FrontlineCheckbox} from "../../Shared/FrontlineCheckbox";
import React, {useEffect, useRef, useState} from "react";
import {useStores} from "../../../Hooks";
import SearchIcon from "@mui/icons-material/Search";
import {observer} from "mobx-react";
import {LoadMoreStateEnum} from "../../../serverClientShared/sharedEnums"
import ConditionalComponent from "../../Shared/ConditionalComponent";
import CloseIcon from '@mui/icons-material/Close';

export const EditMirrorItems = observer(() => {
    const {workspaceManagementStore, modalStore} = useStores();
    const [loading, setLoading] = useState(false);
    const projectListRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const renderSelectOrUnselectAll = () => {
        const isSelect = workspaceManagementStore.selectAllButtonState;
        const buttonText = isSelect ? "Unselect all": "Select all";
        const handleSelectButton = async()=> {
            if (loading) return null
           try {
                 setLoading(true);
                 workspaceManagementStore.loading = true
                 workspaceManagementStore.handleSelectOrUnselectAllMirrorProjects(isSelect)
           } finally {
                workspaceManagementStore.loading = false
               setLoading(false);
           }
        }

        return (
            <button
                onClick={handleSelectButton}
                className="flex flex-row text-link-normal items-end justify-end py-2"
                data-testid="mirror-projects-select-all"
            >
                {buttonText}
            </button>
        );
    };

    const handleSearch = (e) => {
        const newSearchInput = e.target.value.trim();
        if (newSearchInput === workspaceManagementStore.searchInput) return;
        workspaceManagementStore.loadMoreState['Modal'] = LoadMoreStateEnum.LOADING;

        try {
            workspaceManagementStore.searchInput = newSearchInput;
            workspaceManagementStore.handleSearchMirrorItems();
        } catch {
            modalStore.showErrorMessage('Could not fetch workspace projects')
        }

    }


    const renderProject = (project, index) => {
         const render = workspaceManagementStore.render

        const checked = workspaceManagementStore.isProjectChecked(project)
        const onCLick = (e)=>{
            if (e.nativeEvent.shiftKey){
                workspaceManagementStore.handleShiftClick(index, checked)
            } else{
                workspaceManagementStore.currentShiftClickProject = null;
            }
        }
        return (
            <div key={project.ProjectIdentifier} className="flex flex-row w-full justify-between items-center" data-testid={`mirror-project-${project.ProjectName}`}>
                <div className="truncate overflow-hidden whitespace-nowrap w-80">
                    {project.ProjectName}
                </div>
                <FrontlineCheckbox isChecked={checked} onChange={()=>{
                    workspaceManagementStore.handleCheckOrUncheck(project,checked)
                    workspaceManagementStore.render = !workspaceManagementStore.render;
                }}
                onClick={onCLick}
                size={40}/>
            </div>
        );
    }

    const renderSearchBox = () => {
        return (
            <div className="absolute flex flex-col w-full px-10 top-28 bg-white  z-1">
                <div className=" flex flex-row justify-between border-b-2 border-b-main-normal">
                    <div className="flex w-full flex-row items-center ">
                        <SearchIcon/>
                        <input
                            ref={inputRef}
                            type="text"
                            placeholder="Search for name..."
                            className="text-inputfield-normal-text w-full outline-none border-none"
                            onChange={handleSearch}
                            data-testid="mirror-projects-search"
                        />
                        <ConditionalComponent if ={workspaceManagementStore.searchInput && workspaceManagementStore.searchInput.length > 0}>
                            <CloseIcon className="cursor-pointer" onClick={async()=>{
                                inputRef.current.value = ''
                                await handleSearch({target:{value:''}})

                            }}/>
                        </ConditionalComponent>
                    </div>
                </div>
                {renderSelectOrUnselectAll()}
            </div>

        )
    }
    return (
        <div className="flex flex-col w-full font-sans items-center" style={{height:'500px',overflow: 'hidden' }}>
            {renderSearchBox()}
            <div
                ref={projectListRef}
                style={{height: '350px'}}
                className="absolute w-full pr-8 pl-10 top-44 overflow-y-auto z-0"
            >
                {workspaceManagementStore.domainProjects.map((project, index) => renderProject(project, index))}
                {loading && (
                    <div className="text-center text-gray-500">{workspaceManagementStore.loadMoreState['Modal']}</div>
                )}
            </div>
        </div>
    )

})